import { DocumentData, Timestamp } from "firebase/firestore";
import { User } from "../types/User";

export function mapSnapshotToUser(id: string, snapshot: DocumentData): User {
  return {
    uid: id,
    email: snapshot.email,
    createdAt: !!snapshot.createdAt ? snapshot.createdAt : Date.now(),
    onboardingCompleted: snapshot.onboardingCompleted,
    usernameUpdateCount: snapshot.usernameUpdateCount,
    nextUsernameUpdateAt: snapshot.nextUsernameUpdateAt ?? Timestamp.now(),
    blockedUsers: snapshot.blockedUsers ?? [],
  };
}
